import { z } from 'zod';

export const marketingPreferencesGetResponseSchema = z.object({
  data: z.object({ value: z.string().optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
